import React from 'react';
import styles from './Card.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const PADDING = { sm: 'psm', md: 'pmd', lg: 'plg', xl: 'pxl' };

const Card = React.forwardRef(function Card(
  {
    children,
    variant = 'default',
    padding = 'md',
    interactive = false,
    as: Tag = 'div',
    className,
    ...rest
  },
  ref
) {
  const cls = clsx(
    styles.card,
    styles[variant],
    styles[PADDING[padding]],
    interactive && styles.interactive,
    className
  );
  return (
    <Tag ref={ref} className={cls} {...rest}>
      {children}
    </Tag>
  );
});

export default Card;
